import e from "./_nativeCreate.js";
var n = "__lodash_hash_undefined__", o = Object.prototype, _ = o.hasOwnProperty;
function h(a) {
  var r = this.__data__;
  if (e) {
    var t = r[a];
    return t === n ? void 0 : t;
  }
  return _.call(r, a) ? r[a] : void 0;
}
export {
  h as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_hashGet.js
// module id = 1476
// module chunks = 41